export default "__VITE_ASSET__b1a68a69__"